export const Logo = () => {
  return (
    <a href="/" className="flex items-center">
      <div className="w-7 mb-2">
        <img width="100" height="50" src="/uploads/hos_logo.png" />
      </div>
    </a>
  );
};

export default Logo;
